import React, { createContext, useState, useContext, useEffect } from 'react'
import { PopupComponent } from '../components/popupComponent'

interface PopupContextInterface {
    open: (config: PopupConfig) => void
    close: () => void
}
const PopupContext = createContext<PopupContextInterface>({
    open: () => { },
    close: () => { }
})

export interface PopupConfig {
    title: string
    message: any
    type: 'info' | 'confirm'
    onDismiss?: () => void
    onAction?: (value: boolean) => void
    confirmButtonText?: string
    cancelButtonText?: string
    confirmButtonClass?: string
    cancelButtonClass?: string
}

interface ComponentProps {
    children: any
}
export const PopupProvider: React.FC<ComponentProps> = ({ children }) => {
    const [isOpen, setIsOpen] = useState<any>(false)
    const [config, setConfig] = useState<PopupConfig>({
        title: 'Confirm ?',
        message: 'Are you sure? please confirm to continue',
        type: 'confirm',
    })
    const open = (config: PopupConfig) => {
        setIsOpen(true)
        setConfig(config)
    }
    const close = () => {
        setIsOpen(false)
    }

    useEffect(() => {
      if(isOpen === false) {
        if (config.onDismiss) config.onDismiss()
      }
    }, [isOpen, config])
    
    return (
        <PopupContext.Provider value={{ open, close }}>
            <PopupComponent isOpen={isOpen} config={config} setIsOpen={setIsOpen} />
            {children}
        </PopupContext.Provider>
    )
}

export const usePopup = () => useContext(PopupContext)